export enum AllowedUserTypes {
  OWNER = 'OWNER',
  SUPERADMIN = 'SUPERADMIN',
  ADMIN = 'ADMIN',
  STAFF = 'STAFF',
}
